import axiosInstance from "./api_helper";

const supplierService = {
    search: async ({ query = '', page = 0, size = 10 }) => {
        return axiosInstance.get('/api/suppliers/search', {
          params: { query, page, size }
        });
      },
    delete: async (id) => {
        return axiosInstance.delete(`/api/suppliers/${id}`);
    },
    save: async (stock) => {
        return axiosInstance.post(`/api/suppliers`, JSON.stringify(stock));
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/suppliers/${payload.id}`, JSON.stringify(payload.stock));
    },

};
export default supplierService;
